import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNullOrEmpty'
})
export class IsNullOrEmptyPipe implements PipeTransform {

  transform(input:string|null|undefined): boolean {
    
    if (typeof input === 'undefined' || input == null) return true;

    return input.replace(/\s/g, '').length < 1;
  }

}
